module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/events-2015-10-07.paginators.json
// module id = 508
// module chunks = 0